import { HttpEvent, HttpEventCallbacks, httpPost } from "@/events/eventsDomain";
import type {
  OwnershipImportRequest,
  OwnershipImportResponse,
  OwnershipImportSheet,
} from "./ownershipImportDomain";

const base = (accountId: string) =>
  `/enterprise-accounts/${encodeURIComponent(accountId)}/ownership/spreadsheet`;

export const ownershipImportApiClient = {
  read: (
    accountId: string,
    file: File,
    params: HttpEventCallbacks<OwnershipImportSheet>,
  ): HttpEvent<OwnershipImportSheet> => {
    const data = new FormData();
    data.append("file", file);
    return httpPost({ url: base(accountId), data, ...params });
  },
  validate: (
    accountId: string,
    data: OwnershipImportRequest,
    params: HttpEventCallbacks<OwnershipImportResponse>,
  ): HttpEvent<OwnershipImportResponse> =>
    httpPost({ url: `${base(accountId)}/validate`, data, ...params }),
  import: (
    accountId: string,
    data: OwnershipImportRequest,
    params: HttpEventCallbacks<OwnershipImportResponse>,
  ): HttpEvent<OwnershipImportResponse> =>
    httpPost({ url: `${base(accountId)}/import`, data, ...params }),
};
